import gql from 'graphql-tag';

const query = gql`
  query GetStripePortalSessionUrl($subscriptionId: Int!, $returnUrl: String) {
    sale {
      stripe {
        portalSession(subscriptionId: $subscriptionId, returnUrl: $returnUrl) {
          url
        }
      }
    }
  }
`;

export default query;
